import { Box, Button, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getBusinessPalette } from './businessPalette';

// CustomButton styling
export const CustomButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    backgroundColor: palette.buttonBg,
    color: '#fff',
    padding: '8px 28px',
    fontSize: '18px',
    fontWeight: 'bold',
    borderRadius: '8px',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    textTransform: 'none',
    marginTop: '20px',
    transition: 'background-color 0.3s ease, transform 0.2s ease',
    '&:hover': {
      backgroundColor: palette.buttonHoverBg,
      boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
      transform: 'translateY(-2px)',
    },
    '&:disabled': {
      backgroundColor: '#CCCCCC',
      color: '#FFFFFF',
      boxShadow: 'none',
    },
  };
});

// FormContainer styling
export const FormContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ theme, businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: palette.formContainerBg,
    padding: '32px',
    borderRadius: '16px',
    boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.1)',
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(3),
    maxWidth: '500px',
    margin: 'auto',
    border: `2px solid ${palette.formContainerBorder}`,
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(4),
      marginTop: theme.spacing(2),
    },
  };
});

// StyledTextField styling
export const StyledTextField = styled(TextField)({
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: 'none',
    },
  },
});

// FormTitle styling for the title "New Customer"
export const FormTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    fontSize: '35px',
    fontWeight: 'bold',
    color: palette.formTitleColor,
    textAlign: 'center',
  };
});

export const NewCustomerLink = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    fontSize: '16px',
    color: 'black',
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: palette.linkHoverColor,
    },
  };
});